import { createContext, useContext } from "react";

import type { ConversationPanelState, DockMode } from "./types";

interface ShellLayoutState {
  conversationPanelState: ConversationPanelState;
  conversationPanelWidth: number;
  dockMode: DockMode;
  isLeftSidebarVisible: boolean;
  isRightSidebarVisible: boolean;
  leftSidebarWidth: number;
  rightSidebarWidth: number;
}

interface ShellLayoutHandlers {
  onConversationPanelWidthChange?: (width: number) => void;
}

export interface ShellLayoutContextValue
  extends ShellLayoutState, ShellLayoutHandlers {}

export const ShellLayoutContext = createContext<ShellLayoutContextValue | null>(
  null,
);
ShellLayoutContext.displayName = "ShellLayoutContext";

export const useShellLayout = (): ShellLayoutContextValue => {
  const context = useContext(ShellLayoutContext);

  if (!context) {
    throw new Error(
      "CircleAIAppShell.Layout sub-components must be used within <CircleAIAppShell.Layout>",
    );
  }

  return context;
};
